import { a as t } from "../../../chunk-OA3DH5LS-40f95340.js";
const o = t("Footer").parts(
  "floatingBar",
  "divider",
  "floatingBarContainerBase",
  "floatingBarActionsContainerBase",
  "floatingBarHeader",
  "selectedItemsContainer",
  "selectedItems",
  "selectedItems",
  "selectedItemsText",
  "actionsContainer",
  "actionsContainerSelectAll",
  "closeButton",
  "closeIcon"
);
export {
  o as FloatingBottomMultiselectActionsAnatomy
};
//# sourceMappingURL=FloatingBottomMultiselectActions.anatomy.es.js.map
